import React from "react";
import { useTranslation } from "react-i18next";

const UserSearch = ({ searchTerm, onSearch }) => {
  const { t } = useTranslation();

  return (
    <div id="kt_table_1_filter" className="dataTables_filter">
      <label>
        {t("Recherche")}:
        <input
          id="myInput"
          type="text"
          defaultValue={searchTerm}
          onKeyUp={onSearch}
          className="form-control form-control-sm"
          placeholder={t("Nom")}
          aria-controls="kt_table_1"
        />
      </label>
    </div>
  );
};

export default UserSearch;
